// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
    'use strict';

    // Focus input if Searchform is empty
    [].forEach.call(document.querySelectorAll('.search-form'), (el) => {
        el.addEventListener('submit', function (e) {
            var search = el.querySelector('input');
            if (search.value.length < 1) {
                e.preventDefault();
                search.focus();
            }
        });
    });

    // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            trigger: 'focus',
        });
    });
})();

jQuery(document).ready(function ($) {
    if (document.getElementById('ecoBeforeAfter')) {
        new BeforeAfter({
            id: '#ecoBeforeAfter',
        });
    }

    // var currentPath = window.location.pathname;

    // var taxonomies = ['/oferta/kategorie-produktow', '/kategorie-produktow', '/oferta/zastosowania'];

    // var isMatchedTaxonomy = taxonomies.some(function (taxonomy) {
    //     return currentPath.includes(taxonomy);
    // });

    // if (isMatchedTaxonomy) {
    //     // Pobranie segmentów z URL
    //     var segments = currentPath.split('/').filter(Boolean); // Usuwamy puste segmenty

    //     var targetId = segments[segments.length - 1];

    //     // Sprawdzanie czy istnieje element z danym ID na stronie
    //     if ($('#' + targetId).length) {
    //         $('html, body').animate(
    //             {
    //                 scrollTop: $('#' + targetId).offset().top - 100,
    //             },
    //             1000
    //         );
    //         //console.log('Scrolled to:', targetId);
    //     } else {
    //         //console.log('Element with ID:', targetId, 'not found.');
    //     }
    // } else {
    //     //console.log('Not matched any specified taxonomy.');
    // }

    var isAnimating = false; // flaga, która śledzi czy animacja jest aktualnie w trakcie wykonywania

    $('.toggle-product-list').click(function () {
        if (isAnimating) return; // Jeśli animacja jest w trakcie, nie robimy nic

        var $thisToggle = $(this); // Odniesienie do bieżącego elementu toggle
        var productList = $thisToggle.next('.product-list');

        isAnimating = true; // Ustawiamy flagę na true, oznaczając rozpoczęcie animacji

        productList.slideToggle(function () {
            // Sprawdzamy czy menu jest otwarte
            if (productList.is(':visible')) {
                $thisToggle.addClass('opened');
            } else {
                $thisToggle.removeClass('opened');
            }

            isAnimating = false; // Resetujemy flagę, oznaczając zakończenie animacji
        });
    });

    $('.product-gallery').slick({
        arrows: true,
        asNavFor: '.product-gallery-small',
        prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 1.2L6.66666 -5.82821e-08L-1.57026e-07 5.99997L6.66663 12L7.99997 10.8L2.66664 5.99997L8 1.2Z" fill="white"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 1.2L6.66666 -5.82821e-08L-1.57026e-07 5.99997L6.66663 12L7.99997 10.8L2.66664 5.99997L8 1.2Z" fill="white"/></svg></button>',
    });
    $('.product-gallery-small').slick({
        infinite: true,
        slidesToShow: 3,
        asNavFor: '.product-gallery',
        arrows: false,
    });

    $(window).on('load resize', function (e) {
        var col_left = $('.col-photo-left');
        var img_left = $('.left-photo');
        if ($(window).width() > 992) {
            if (col_left.length && img_left.length) {
                var offset = col_left.offset();
                var value = '-' + (offset.left + 12) + 'px';
                var value2 = col_left.width() + offset.left + 'px';
                $(img_left).css('left', value);
                $(img_left).css('width', value2);
            }
        } else {
            $(img_left).removeAttr('style');
        }
        var col_right = $('.container-xl');
        var img_right = $('.title-wrapper');
        if ($(window).width() > 992) {
            if (col_right.length && img_right.length) {
                offset = img_right.offset();
                var offset = $(window).width() - (offset.left + img_right.width());
                var value2 = img_right.width() + offset + 'px';
                $(img_right).css('width', value2);
            }
        } else {
            $(img_right).removeAttr('style');
        }
    });

    // Navbar
    function navbar() {
        if (($(window).scrollTop() > 10 && !$('.navbar').hasClass('navbar--scroll')) || ($(window).scrollTop() === 0 && $('.navbar').hasClass('navbar--scroll'))) {
            $('.navbar').toggleClass('navbar--scroll');
        }
    }
    $(window).scroll(function () {
        navbar();
    });
    $(document).ready(function () {
        navbar();
    });

    var $status = $('.pagingInfo');
    var $slickElement = $('.home-slider');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        if (slick.slideCount < 10) {
            var zero = '0';
        } else {
            zero = '';
        }

        $status.html('<div class="count"><span>' + zero + i + '</span><span>/</span>' + '<span class="total"> ' + zero + slick.slideCount + '</span>' + '</div>');
    });
    $slickElement.slick({
        arrows: true,
        fade: true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        mobileFirst: true,
        appendArrows: '.belt-paging > .arrows',
        prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"/></svg></button>',
    });

    $('.sectors-slider').slick({
        slidesToShow: 6,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 1.2L6.66666 -5.82821e-08L-1.57026e-07 5.99997L6.66663 12L7.99997 10.8L2.66664 5.99997L8 1.2Z" fill="white"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 1.2L6.66666 -5.82821e-08L-1.57026e-07 5.99997L6.66663 12L7.99997 10.8L2.66664 5.99997L8 1.2Z" fill="white"/></svg></button>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    });

    $('.business-slider').slick({
        infinite: true,
        dots: true,
        slidesToShow: 5,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    });

    $('#navbar').on('show.bs.collapse', function () {
        $('.navbar ').addClass('navbar--open');
    });

    $('#navbar').on('hide.bs.collapse', function () {
        $('.navbar ').removeClass('navbar--open');
    });

    lightbox.option({
        resizeDuration: 200,
        wrapAround: true,
        albumLabel: 'Zdjęcie %1 z %2',
        disableScrolling: true,
        fadeDuration: 200,
        imageFadeDuration: 200,
        resizeDuration: 200,
        alwaysShowNavOnTouchDevices: true,
    });

    // Funkcja do obsługi zdarzenia scroll
    function handleScroll() {
        var timelineOffset = $('.timeline').offset().left;
        var scrollLeft = $(window).scrollLeft();

        var closestTimePicker = null;
        var closestDistance = Infinity;

        $('.timeline .time-picker').each(function () {
            var timePickerOffset = $(this).offset().left;
            var distanceFromLeft = timePickerOffset - timelineOffset - scrollLeft;

            if (distanceFromLeft >= 0 && distanceFromLeft < closestDistance) {
                closestTimePicker = this;
                closestDistance = distanceFromLeft;
            }
        });
        $('.timeline .time-picker').removeClass('active');
        $(closestTimePicker).addClass('active');

        var scrollLeft = $('.timeline').scrollLeft();

        // Sprawdź, czy .timeline jest przewinięte co najmniej o 160px od lewej krawędzi
        if (scrollLeft <= 20) {
            $('.timeline-prev').prop('disabled', true);
        } else {
            $('.timeline-prev').prop('disabled', false);
        }

        var scrollLeft = timeline.scrollLeft();
        var scrollWidth = timeline.get(0).scrollWidth;
        var clientWidth = timeline.width();

        // Sprawdź, czy .timeline jest przewinięty do końca
        if (scrollLeft + clientWidth >= scrollWidth) {
            $('.timeline-next').prop('disabled', true);
        } else {
            $('.timeline-next').prop('disabled', false);
        }
    }

    // Wywołaj funkcję handleScroll przy ładowaniu strony i przy zdarzeniu scroll
    $('.timeline').on('scroll load', handleScroll);

    var timeline = $('.timeline');
    var timePicker = $('.time-picker');

    var contentWidth = timeline.width();
    var timePickerWidth = timePicker.innerWidth();
    var spacer = contentWidth - timePickerWidth - 40;
    $('.spacer').css('--width', spacer + 'px');

    // Arrows

    var isAnimating = false;

    function scrollRight() {
        if (!isAnimating) {
            isAnimating = true;
            $('.timeline').animate({scrollLeft: '+=' + 160}, 500, function () {
                isAnimating = false;
            });
        }
    }

    function scrollLeft() {
        if (!isAnimating) {
            isAnimating = true;
            $('.timeline').animate({scrollLeft: '-=' + 160}, 500, function () {
                isAnimating = false;
            });
        }
    }
    $('.timeline-next').on('click', scrollRight);

    $('.timeline-prev').on('click', scrollLeft);

    $(window).on('load resize', function (e) {
        if ($(window).width() > 992) {
            $('.time-picker').on('click', function () {
                var timeline = $('.timeline');
                var timePickerOffset = $(this).offset().left;
                var allOffset = timeline.scrollLeft() + timePickerOffset - 270;
                // console.log('Odległość od lewej: ' + timePickerOffset);
                // console.log('Odległość od  opakowania: ' + timeline.scrollLeft());
                // console.log('Odległość od lewej prawidlowa: ' + allOffset);
                timeline.animate({scrollLeft: allOffset}, 500);
            });
        }
    });

    var sectionAboutUs = $('#aboutUs');
    if (sectionAboutUs.length > 0) {
        var controller2 = new ScrollMagic.Controller();

        function checkScreenWidth() {
            var screenWidth = window.innerWidth;
            if (screenWidth > 768) {
                var scene = new ScrollMagic.Scene({
                    triggerElement: '#aboutUs',
                    triggerHook: '0',
                    duration: window.innerHeight,
                }).setPin('#aboutUs');
                // .addIndicators();

                var tabs = $('.nav-pills .nav-link');
                function switchTabs(currentIndex) {
                    tabs.eq(currentIndex).click();
                }

                var prevButton = $('.arrow-left');
                var nextButton = $('.arrow-right');

                scene.on('progress', function (e) {
                    var progress = scene.progress();
                    if (progress < 0.25) {
                        switchTabs(0);
                        activateImage(0);
                        prevButton.attr('disabled', 'true');
                    } else if (progress < 0.5) {
                        switchTabs(1);
                        activateImage(1);
                        prevButton.removeAttr('disabled');
                    } else if (progress < 0.75) {
                        switchTabs(2);
                        activateImage(2);
                        nextButton.removeAttr('disabled');
                    } else {
                        switchTabs(3);
                        activateImage(3);
                        nextButton.attr('disabled', 'true');
                    }
                });

                prevButton.on('click', function () {
                    var currentPosition = window.pageYOffset || document.documentElement.scrollTop;
                    var targetPosition = currentPosition - 300;

                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth',
                    });
                });

                nextButton.on('click', function () {
                    var currentPosition = window.pageYOffset || document.documentElement.scrollTop;
                    var targetPosition = currentPosition + 300;

                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth',
                    });
                });

                function activateImage(index) {
                    var images = $('.about-us-image');
                    images.removeClass('active');
                    images.eq(index).addClass('active');
                }

                controller2.addScene(scene);
            }
            // else {
            //     var tabs = $('.nav-pills .nav-link');
            //     var images = $('.about-us-image');
            //     var activeTabIndex = getActiveTab();

            //     tabs.on('click', function () {
            //         var clickedTabIndex = tabs.index(this);
            //         if (activeTabIndex !== clickedTabIndex) {
            //             images.eq(activeTabIndex).removeClass('active');
            //             images.eq(clickedTabIndex).addClass('active');
            //             activeTabIndex = clickedTabIndex;
            //         }
            //     });
            // }
        }

        checkScreenWidth();

        $(window).on('resize', function () {
            checkScreenWidth();
        });
    }

    var sectionMap = document.querySelector('.section-map-svg');
    if (sectionMap) {
        const controller = new ScrollMagic.Controller();
        const map = new ScrollMagic.Scene({
            triggerElement: '.section-map-svg',
            triggerHook: '0.2',
        }).setClassToggle('.map-figure', 'zoom-in');

        controller.addScene(map);
    }

    $(window).scroll(function () {
        if ($(this).scrollTop() >= 1) {
            // Znajdź element .EU-fixed > span i ustaw jego opacity na 0
            $('.UE-fixed > span').css('opacity', 0);
        } else {
            // Jeśli strona nie jest przewinięta, przywróć opacity
            $('.UE-fixed > span').css('opacity', 1);
        }
    });

    // Popup
    var $popup = $('.popup');

    if ($popup.length) {
        var delayTime = parseInt($popup.data('delay-time')) * 1000;
        var cookiesTime = parseInt($popup.data('cookies-time')) * 3600;

        function setCookie(name, value, seconds) {
            var expires = '';
            if (seconds) {
                var date = new Date();
                date.setTime(date.getTime() + seconds * 1000);
                expires = '; expires=' + date.toUTCString();
            }
            document.cookie = name + '=' + (value || '') + expires + '; path=/';
        }

        function getCookie(name) {
            var nameEQ = name + '=';
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        }

        function getScrollbarWidth() {
            var outer = document.createElement('div');
            outer.style.visibility = 'hidden';
            outer.style.width = '100px';
            outer.style.msOverflowStyle = 'scrollbar';
            document.body.appendChild(outer);
            var widthNoScroll = outer.offsetWidth;
            outer.style.overflow = 'scroll';
            var inner = document.createElement('div');
            inner.style.width = '100%';
            outer.appendChild(inner);
            var widthWithScroll = inner.offsetWidth;
            outer.parentNode.removeChild(outer);
            return widthNoScroll - widthWithScroll;
        }

        var scrollbarWidth = getScrollbarWidth();

        if (!getCookie('popup_closed')) {
            setTimeout(function () {
                $('.popup').removeClass('popup--hidden');
                $('#popup-overlay').fadeIn();
                $('body')
                    .addClass('no-scroll')
                    .css('padding-right', scrollbarWidth + 'px'); // Dodanie padding-right
            }, delayTime);

            $('#popup-close').on('click', function () {
                $('#popup-overlay').fadeOut(function () {
                    $('body').removeClass('no-scroll').css('padding-right', ''); // Usunięcie padding-right
                    $popup.addClass('popup--hidden'); // Dodanie klasy popup--hidden po zakończeniu animacji
                });
                setCookie('popup_closed', 'true', cookiesTime);
            });

            $('.popup-inner a').on('click', function () {
                setCookie('popup_closed', 'true', cookiesTime);
            });
        }
    }
});

// Znajdź wszystkie wystąpienia znaku ® w elemencie body
const bodyElement = document.body;
const regex = /®/g;
const bodyHTML = bodyElement.innerHTML;

// Zamień każde wystąpienie znaku ® na <sup>®</sup>
const modifiedHTML = bodyHTML.replace(regex, '<sup>$&</sup>');
bodyElement.innerHTML = modifiedHTML;
